import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { isSoundEnabled, toggleSound } from '../utils/soundEffects';

const { FiVolumeX, FiVolume2 } = FiIcons;

const SoundToggle = ({ className = '' }) => {
  const [soundOn, setSoundOn] = useState(true);
  
  useEffect(() => {
    // Initialize sound state from local storage
    setSoundOn(isSoundEnabled());
  }, []);
  
  const handleToggle = () => {
    const newState = toggleSound();
    setSoundOn(newState);
  };
  
  return (
    <motion.button
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={handleToggle}
      className={`p-2 rounded-full transition-all ${className} ${
        soundOn ? 'bg-green-500/30 text-green-300' : 'bg-red-500/30 text-red-300'
      }`}
      aria-label={soundOn ? 'Turn sound off' : 'Turn sound on'}
    >
      <SafeIcon icon={soundOn ? FiVolume2 : FiVolumeX} className="text-lg" />
    </motion.button>
  );
};

export default SoundToggle;